import SectionHeading from './SectionHeading';
import { collections } from '@/mocks/collections';

export default function FullCollections() {
  return (
    <section
      id="collection"
      className="scroll-mt-16 bg-background-100 py-14 md:py-20 border-t border-background-200/70"
    >
      <div className="px-4 md:px-8">
        <SectionHeading
          icon="ri-stack-line"
          eyebrow="全集速看"
          title="全集：按主题打包的整季条目集合"
          desc="「全集」不是单集，而是把同一主题下相对完整的剧集整理成一组，省去逐条查找的麻烦。每组都标注了条目数量与主要标签，适合按兴趣成组浏览。"
          tone="secondary"
        />

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          {collections.map((col) => (
            <article
              key={col.id}
              className="flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200 transition-colors hover:border-secondary-400"
            >
              <div className="w-full sm:w-40 shrink-0 h-40 sm:h-36 rounded-md overflow-hidden bg-background-200">
                <img
                  src={col.poster}
                  alt={`${col.title}合集封面`}
                  className="w-full h-full object-top"
                />
              </div>
              <div className="flex flex-col min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{col.title}</h3>
                  <span className="shrink-0 px-2 py-0.5 text-xs rounded-md bg-accent-100 text-accent-800">
                    {col.count} 条目
                  </span>
                </div>
                <p className="mt-2 text-xs leading-5 text-foreground-600">{col.desc}</p>
                <div className="mt-auto pt-3 flex flex-wrap gap-1.5">
                  {col.tags.map((tag) => (
                    <span key={tag} className="px-2 py-0.5 text-xs rounded-full bg-secondary-100 text-secondary-900">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}